export default __webpack_public_path__ + "static/media/layamr-web1.a2bc03b2.jpg";